/**
 * Presentation for a Starlink connection status (ISS-021/022).
 *
 * The backend (deviceSystems.js + the health-check normaliser) can emit the full
 * range of states — online, offline, idle, suspended, degraded, unknown — plus
 * the synthetic 'not_activated', which deviceSystems uses INTENTIONALLY for a
 * unit with no terminal linked (not a stale value; keep it). This is the one
 * place that maps a status to a Badge variant, using only EXISTING theme variants
 * so no colour is invented.
 */
export type BadgeVariant = 'success' | 'destructive' | 'secondary' | 'warning' | 'outline';

export function connectionStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'online':
      return 'success';
    case 'offline':
      return 'destructive';
    case 'idle':
      return 'secondary';
    // The sync's mid-tier verdicts: a suspended (cancelled) line and a degraded
    // link both warrant attention without being a hard outage.
    case 'suspended':
    case 'degraded':
      return 'warning';
    // 'unknown' (no sync verdict yet), 'not_activated' (no terminal), and any
    // future state read as neutral rather than misleading green/red.
    default:
      return 'outline';
  }
}
